"use strict";

module.exports = require('./runtime/styled'); // eslint-disable-line